import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=5c7ebd90&scoped=true&lang=pug"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"
import style0 from "./TabMenu.vue?vue&type=style&index=0&id=5c7ebd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ebd90",
  null
  
)

export default component.exports